import { FilterResult } from '../../../repository.service';
import { Component, OnInit, Input } from '@angular/core';
import { FormControlComponent } from '../form-control.component';
import { Observable } from 'rxjs';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { FormControl as WncmFormControl } from '../form-control.model';

export const _filter = (opt: any[], value: string): string[] => {
	const filterValue = value.toLowerCase();
	return opt.filter((item) => item.name.toLowerCase().indexOf(filterValue) === 0);
};

@Component({
	selector: 'wncm-form-control-select-with-group-multiple',
	templateUrl: './form-control-select-with-group-multiple.component.html',
	styleUrls: ['../form-control.component.scss', './form-control-select-with-group-multiple.component.scss']
})
export class FormControlSelectWithGroupMultipleComponent extends FormControlComponent implements OnInit {
	inputControl: WncmFormControl;

	optionForm: UntypedFormGroup = this.fb.group({
		optionGroup: ''
	});

	@Input()
	from: Observable<FilterResult<any>>;

	@Input()
	label: string;

	@Input() parentFormGroup: UntypedFormGroup;

	@Input()
	readOnly: boolean;

	options = [];

	displayedOptions: Observable<any[]>;

	public selectedOptions: Array<any> = new Array<any>();

	private items: FilterResult<any>;

	constructor(private translate: TranslateService, private fb: UntypedFormBuilder) {
		super();

		if (this.readOnly) {
			this.control.disable();
		}
	}

	initInputTxt() {
		this.options.forEach((opt) => {
			opt.activities.forEach((act) => {
				if (act.id === this.control.value) {
					this.inputControl.setValue(act.name);
				}
			});
		});
	}

	ngOnInit() {
		this.inputControl = new WncmFormControl('inputControl');

		if (this.parentFormGroup != null) {
			this.parentFormGroup.addControl('inputControl', this.inputControl);
		}

		this.control.validators$.value.forEach((next) => {
			this.inputControl.addValidator(next);
		});

		this.control.validationMessages$.value.forEach((next) => {
			this.inputControl.addValidationMessage(next);
		});

		this.control.statusChanges.subscribe((c) => {
			this.inputControl.markAsTouched();

			if (c === 'INVALID' && !this.control.value) {
				this.inputControl.setValue(null);
			}
		});

		this.control.valueChanges.subscribe((v) => {
			this.initInputTxt();
		});
		super.ngOnInit();
		this.from.subscribe((items) => {
			this.items = items;
			this.refreshOptions();
		});

		this.displayedOptions = this.inputControl.valueChanges.pipe(
			startWith(''),
			map((value) => this._filterGroup(value))
		);
	}

	private refreshOptions() {
		this.options = this.items.items;
		this.initInputTxt();
	}

	private _filterGroup(value: string): any[] {
		if (value) {
			return this.options
				.map((group) => ({ name: group.name, activities: _filter(group.activities, value) }))
				.filter((group) => group.activities.length > 0);
		}

		return this.options;
	}

	onEnter(evt: any) {
		this.control.setValue(evt.id);
	}

	displayFn(value: any[] | string): string | undefined {
		let displayValue: string;
		if (Array.isArray(value)) {
			value.forEach((activity, index) => {
				if (index === 0) {
					displayValue = activity.name;
				} else {
					displayValue += ', ' + activity.name;
				}
			});
		} else {
			displayValue = value;
		}
		return displayValue;
	}

	optionClicked(event: Event, activity: any) {
		event.stopPropagation();
		this.toggleSelection(activity);
	}

	toggleSelection(activity: any) {
		activity.selected = !activity.selected;
		if (activity.selected) {
			this.selectedOptions.push(activity);
		} else {
			const i = this.selectedOptions.findIndex((value) => value.id === activity.id);
			this.selectedOptions.splice(i, 1);
		}
		this.inputControl.setValue(this.selectedOptions);
		const previousArr = this.control.value;
		const idsChecked = this.inputControl.value.map((s) => s.id);

		this.control.setValue(Array.from(new Set(previousArr.concat(idsChecked))));
	}
}

export class SelectOption {
	id: any;
	label: string;
}
